const skipToMain = document.querySelector('.skip-link');
const mainContent = document.getElementById('primary');
if (mainContent) {
	mainContent.setAttribute('tabindex', '-1');
}
if (skipToMain) {
	skipToMain.addEventListener('click', function (e) {
		e.preventDefault();
		document.getElementById('primary').focus();
		document.querySelector(this.getAttribute('href')).scrollIntoView({
			behavior: 'smooth',
		});
	});
}
